import http from "./http";

export const fetchTemplates = () => http.get("/core-basics/templates/");

export const fetchPlans = () => http.get("/core-basics/plans/");

export const fetchProvinces = () => http.get("/core-basics/provinces/");

export const fetchCities = (provinceId) =>
  http.get(`/core-basics/cities/?province_id=${provinceId}`);

// ➕ این را باید اضافه کنی
export const fetchStoreTypes = () => http.get("/core-basics/store-types/");

export const createStoreRequest = (data) =>
  http.post("/stores/my-stores/", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const fetchMyStores = () => http.get("/stores/my-stores/");
export const fetchSupportStores = () => http.get("/stores/support-stores/");

export const checkSlug = async (slug) => {
  return http.get(`/stores/check-slug/`, {
    params: { slug },
  });
};

export const submitPendingStoreRequest = (data) =>
  http.post("/stores/pending-store/submit/", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const fetchMyPendingStores = () => http.get("/stores/pending-store/my/");

export const fetchAdminPendingStores = () =>
  http.get("/stores/pending-store/admin/list/");

export const reviewPendingStore = (pk, action, note = "") =>
  http.post(`/stores/pending-store/admin/review/${pk}/`, { action, note });

export const initiatePayment = (pendingId) =>
  http.post("/stores/payment/initiate/", { pending_id: pendingId });

export const retryPaymentOrUpdateTx = (pendingId, data) =>
  http.post(`/stores/pending-store/${pendingId}/retry/`, data);
